import styled from 'styled-components';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

export const Title = styled(Heading).attrs({ size: 'lg' })`
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
  margin-top: ${({ theme }) => theme.spacings.abs24}px;
`;

export const Description = styled(Text)`
  white-space: pre-line;
`;
